/* import { AppDispatch } from "../../store";
import { startLogout } from "../../store/auth";

import { useDispatch } from "react-redux"; */
/* 
import * as React from 'react'; */

import { AppBar, Box, IconButton, Menu, MenuItem, Toolbar, Tooltip, Typography } from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';
/* import { ManageAccountsSharp, } from "@mui/icons-material";
import { Link as RouterLink } from 'react-router-dom'; */


type appbarComponentProps = {
    drawerWidth: number;
    title: string
    handleDrawerToggle: any
};



export const AdminAppBar = ({ drawerWidth, handleDrawerToggle }: appbarComponentProps) => {

 /*    const dispatch = useDispatch<AppDispatch>();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
 */
 /*    const handleUserMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleUserMenuClose = () => {
        setAnchorEl(null);
    };
 */
  /*   const handleLogout = () => {
        dispatch(startLogout());

        handleUserMenuClose();// Asegúrate de que esta redirección refleje el nuevo estado
    };
 */

    return (
        <AppBar
            position="fixed"
            
            sx={{
                width: { sm: `calc(100% - ${drawerWidth}px)` },
                ml: { sm: `${drawerWidth}px` },
                backgroundColor: '#FFF', // Cambia el color de fondo a blanco
                color: '#000', // Cambia el color del texto y los íconos a negro
                '.MuiIconButton-root': { // Aplica estilos a todos los IconButton dentro del AppBar
                    color: 'inherit', // Asegura que el color de los íconos herede del color del AppBar
                },

            }}
        >
            
            <Toolbar  sx={{ display: { sm: 'none' } }}>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    onClick={handleDrawerToggle}
                    sx={{ mr: 2, display: { sm: 'none' } }}
                >
                    <MenuIcon />
                </IconButton>

                {/* menu web en la parte blanca */}
                <Typography variant='h5' component="div" sx={{ flexGrow: 1, fontWeight: 700 }} color={'primary'}>
                    Academia Mejias
                </Typography>


           {/*      <Box sx={{ flexGrow: 0 }}>
                    <Tooltip title="Opciones de cuenta">
                        <IconButton onClick={handleUserMenuOpen} sx={{ p: 0 }}>
                            <ManageAccountsSharp />
                        </IconButton>
                    </Tooltip>
                    <Menu
                        sx={{ mt: '45px' }}
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={Boolean(anchorEl)}
                        onClose={handleUserMenuClose}
                    >

                        <MenuItem component={RouterLink} to={''} onClick={handleUserMenuClose}>Editar cuenta</MenuItem>
                        <MenuItem component={RouterLink} to={'/'} onClick={handleLogout} >Cerrar sesión</MenuItem>
                    </Menu>
                </Box> */}

            </Toolbar>
        </AppBar>
    );
};
